import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { batchLoadTiers, batchEditTier } from '../../../actions/studio';
import { Props } from './TierBatchEdit';
import { AppState } from '../../../types/store';

export type StateProps = Pick<Props, 'tiers' | 'isLoading'>;
export type DispatchProps = Pick<Props, 'batchLoadTiers' | 'batchEditTier'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  tiers: state.studio!.tiers,
  isLoading: state.studio!.batchActionLoading,
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  batchLoadTiers,
  batchEditTier,
};

export default connect(mapStateToProps, mapDispatchToProps);
